<template>
    <VoipUI>
        <b-icon v-if="iconOnly"
            @click="onClickGroupCall" icon="telephone-fill" :class="'mb-0 h5 '+ callButtonVariant" v-b-tooltip.hover :title="!isCallInProgress && isPhoneOnline ? $t('voip.group_call.make_call') : ''"/>
        <b-button v-else
            @click="onClickGroupCall" size="sm" :variant="callButtonVariant" v-b-tooltip.hover :title="$t('voip.group_call.make_call')">{{ $t('voip.group') }}
            <b-icon icon="telephone" />
        </b-button>
    </VoipUI>
</template>

<script>
import phone from '@/store/dispatching/phone'
import VoipUI from '@/components/Dispatching/VoIP/VoipUI'

export default {
    components: {
        VoipUI
    },    
    props: {
        recipients: {
            default: []
        },
        iconOnly: {
            default: false
        }
    },
    beforeCreate: function() {
        if (!this.$store.state.phone) {
            this.$store.registerModule('phone', phone);
        }
    },
    computed: {
        callButtonVariant() {
            if (this.isCallInProgress() || !this.isPhoneOnline()) {
                return 'secondary';
            }
            return 'success';
        }
    },
    methods: {
        callStatus() {
            return this.$store.state.phone.phoneState.status;
        },
        isCallInProgress() {
            if (this.callStatus() == "calling" || this.callStatus() == "call_connected") {
                return true;
            }
            return false;
        },
        isPhoneOnline() {
            if (Array.isArray(this.recipients)) {
                for (const sipClientId of this.recipients) {
                    let sipClient = this.$store.state.phone.phonebook[sipClientId];
                    if (sipClient && sipClient.status == 'online') {
                        return true;
                    }
                }
            }
            return false;
        },
        onClickGroupCall() {
            if (!this.isCallInProgress() && this.isPhoneOnline())
                this.$store.commit('phone/requestGroupCall', this.recipients);
        }
    }
}
</script>

<style lang="scss">
.success {
    color: green;
}
.secondary {
    color: grey;
}
</style>